import React from "react";
import * as Styled from "./VehicleComparison.styled";
import Vehicle from "./Vehicle";

function VehicleComparison({isMobile, isTablet}) {
  return (
    <Styled.ComparisonBackground>
      <Styled.MaxWidth>
        <Styled.YellowTopArtfacts />
        <Styled.TitleWrapper>
          <Styled.Title>Petrol vs hybrid vs EV comparison</Styled.Title>
          <Styled.ContentText>
            <Styled.ContentTextTitle>Compare some of the most popular options in the petrol, hybrid and electric ranges</Styled.ContentTextTitle>
            <Styled.ContentTextBody>
              Find the perfect match for your needs, ensuring a vehicle that not
              only fits your lifestyle but also maximises your savings.
            </Styled.ContentTextBody>
          </Styled.ContentText>
        </Styled.TitleWrapper>
        <Vehicle isMobile={isMobile}  isTablet={isTablet} />
        <Styled.Disclaimer>
          * Weekly price assumes a 5 year lease, a driver based in NSW with an annual pre-tax salary of $100,000, and car running costs based on 15,000km driven per year.
        </Styled.Disclaimer>
      </Styled.MaxWidth>
    </Styled.ComparisonBackground>
  );
}

export default VehicleComparison;
